let process_action_data = function (data) {
    window.Smart.utils.convert_callable_strings_to_js(data);

    return data;
}

export default process_action_data;
